<template>
  <form action="" @submit.prevent="submit">
    <TextBox
      type="password"
      label="Current password"
      name="current_password"
      placeholder="Enter your current password"
      v-model="form.current_password"
      :disabled="form.processing"
      :error="form.errors.current_password"
    />
    <TextBox
      type="password"
      label="New password"
      name="password"
      placeholder="Enter your new password"
      v-model="form.password"
      :disabled="form.processing"
      :error="form.errors.password"
    />
    <TextBox
      type="password"
      label="Confirm password"
      name="password_confirmation"
      placeholder="Enter your new password again"
      v-model="form.password_confirmation"
      :disabled="form.processing"
      :error="form.errors.password_confirmation"
    />
    <div class="text-center mt-4">
      <button
        class="btn btn-primary w-75"
        type="submit"
        :disabled="form.processing || !form.isDirty"
        @click.prevent="submit"
      >
        <div
          class="spinner-border spinner-border-sm"
          role="status"
          v-if="form.processing"
        ></div>
        <span v-else>Update password</span>
      </button>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      form: this.$inertia.form({
        current_password: null,
        password: null,
        password_confirmation: null,
      }),
    };
  },
  methods: {
    submit() {
      this.form.post(this.$route("admin.profile.changepassword"), {
        onSuccess: () => this.form.reset(),
      });
    },
  },
};
</script>